var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('child-layout',{attrs:{"title":_vm.title}},[_c('ag-grid-server-side',{attrs:{"id":"userList","server-side-datasource":_vm.serverSideDatasource,"column-defs":_vm.columnDefs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }